import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isDefined } from '@fi-shared/utils';

@Component({
    selector: 'fi-task-v2-edit-deadline',
    templateUrl: './fi-task-v2-edit-deadline.component.html',
    styleUrl: './fi-task-v2-edit-deadline.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-edit-deadline' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiTaskV2EditDeadlineComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiTaskV2EditDeadlineComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiTaskV2EditDeadlineComponent extends ControlValueAccessorValidatorBase<string> implements OnInit {
    @Input() suppressError: boolean = false;
    @Output() datePickerInputFocus = new EventEmitter<void>();

    protected minDeadline: Date;

    ngOnInit(): void {
        this.setMinDeadline();
    }

    protected datePickerChange(): void {
        this.doPropagateChanges();
    }

    protected onDatePickerInputFocus(): void {
        this.datePickerInputFocus.emit();
    }

    private setMinDeadline(): void {
        this.minDeadline = new Date();
        this.minDeadline.setHours(0, 0, 0);
    }
}
